import React from "react"

import Chart from "./Chart"
import StockInfo from "./StockInfo"
import StockStrategy from "./StockStrategy"
import Top from "./Top"


export default function ChartContent() {
  // const { sidebar } = useSidebar()
  // const { width } = useWindowSize()

  const chartRef = React.useRef<HTMLDivElement>(null)

  return (
    <section
      className="contents"
      style={{
        height: "100%",
        width: "100%",
      }}
      // style={{
      //   height: 912,
      //   width: Math.max(
      //     920,
      //     width -
      //       (sidebar.isShowLeft ? 240 : 0) -
      //       (sidebar.isShowRight ? 240 : 0)
      //   ),
      // }}
    >
      <div className="stock_info">
        <Top/>
        {/*<Tools/>*/}
      </div>
      <div className="chart_wrapper" ref={chartRef}>
        {/* <!-- S : 차트 그래프 --> */}
        <Chart/>
        {/* <!-- E : 차트 그래프 --> */}
        <StockInfo chartRef={chartRef}/>
      </div>

        <div className="news_wrap">
          <StockStrategy />
        </div>
      {/*<div className="fix_bot">
        <VolumeController />
        <div className="live_wrap">
          <div className="list" />
          <div className="live">
            <Notice />
            <Leading />
          </div>
        </div>
      </div>*/}
    </section>
  )
}
